import React, { ReactElement } from "react";
import DateInputWithPicker from "../date-selection/date-input-with-picker";
import InputGroup from "../date-selection/input-group";
import { DateRangeFilterProps } from "./filter.types";

const DateRangeFilterInput = ({
  startDate,
  endDate,
  ...rest
}: DateRangeFilterProps): ReactElement => {
  return (
    <InputGroup {...rest}>
      <DateInputWithPicker {...startDate} />
      <DateInputWithPicker {...endDate} />
    </InputGroup>
  );
};

export default DateRangeFilterInput;
